// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Archivo-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("Archivo-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("Archivo-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("Archivo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("Archivo-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("Archivo-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("Archivo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("Archivo-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
    font-family: 'Archivo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: local('Archivo Thin'), local('Archivo-Thin'),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 100;
}

@font-face {
    font-family: 'Archivo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    src: local('Archivo Extra Light'), local('Archivo-ExtraLight'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    font-weight: 200;
}

@font-face {
    font-family: 'Archivo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    src: local('Archivo Light'), local('Archivo-Light'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    font-weight: 300;
}

@font-face {
    font-family: 'Archivo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    src: local('Archivo Regular'), local('Archivo-Regular'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    font-weight: 400;
}

@font-face {
    font-family: 'Archivo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    src: local('Archivo Medium'), local('Archivo-Medium'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    font-weight: 500;
}

@font-face {
    font-family: 'Archivo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    src: local('Archivo Semibold'), local('Archivo-Semibold'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    font-weight: 600;
}

@font-face {
    font-family: 'Archivo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    src: local('Archivo Bold'), local('Archivo-Bold'),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    font-weight: 700;
}

@font-face {
    font-family: 'Archivo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    src: local('Archivo Extra Bold'), local('Archivo-ExtraBold'),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    font-weight: 800;
    font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/view/assets/fonts/fonts.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;IACtB,4CAA4B;IAC5B;2CACuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,4CAAkC;IAClC;2CAC6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,4CAA6B;IAC7B;2CACwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,4CAA+B;IAC/B;2CAC0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,4CAA8B;IAC9B;2CACyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,4CAAgC;IAChC;2CAC2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,4CAA4B;IAC5B;2CACuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,4CAAiC;IACjC;2CAC4B;IAC5B,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["\n@font-face {\n    font-family: 'Archivo';\n    src: url('Archivo-Thin.ttf');\n    src: local('Archivo Thin'), local('Archivo-Thin'),\n    url('Archivo-Thin.ttf');\n    font-weight: 100;\n}\n\n@font-face {\n    font-family: 'Archivo';\n    src: url('Archivo-ExtraLight.ttf');\n    src: local('Archivo Extra Light'), local('Archivo-ExtraLight'),\n    url('Archivo-ExtraLight.ttf');\n    font-weight: 200;\n}\n\n@font-face {\n    font-family: 'Archivo';\n    src: url('Archivo-Light.ttf');\n    src: local('Archivo Light'), local('Archivo-Light'),\n    url('Archivo-Light.ttf');\n    font-weight: 300;\n}\n\n@font-face {\n    font-family: 'Archivo';\n    src: url('Archivo-Regular.ttf');\n    src: local('Archivo Regular'), local('Archivo-Regular'),\n    url('Archivo-Regular.ttf');\n    font-weight: 400;\n}\n\n@font-face {\n    font-family: 'Archivo';\n    src: url('Archivo-Medium.ttf');\n    src: local('Archivo Medium'), local('Archivo-Medium'),\n    url('Archivo-Medium.ttf');\n    font-weight: 500;\n}\n\n@font-face {\n    font-family: 'Archivo';\n    src: url('Archivo-SemiBold.ttf');\n    src: local('Archivo Semibold'), local('Archivo-Semibold'),\n    url('Archivo-SemiBold.ttf');\n    font-weight: 600;\n}\n\n@font-face {\n    font-family: 'Archivo';\n    src: url('Archivo-Bold.ttf');\n    src: local('Archivo Bold'), local('Archivo-Bold'),\n    url('Archivo-Bold.ttf');\n    font-weight: 700;\n}\n\n@font-face {\n    font-family: 'Archivo';\n    src: url('Archivo-ExtraBold.ttf');\n    src: local('Archivo Extra Bold'), local('Archivo-ExtraBold'),\n    url('Archivo-ExtraBold.ttf');\n    font-weight: 800;\n    font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
